import React, { Component } from 'react';
import { Carousel } from 'antd-mobile';
import { ApiGetBannerConf } from '@/api/index';
import { getProxyConfig } from '@/utils/utils';

class BannerRef extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bannerData: [],
      slideIndex: 0,
    }
  }
  
  getList() {
    ApiGetBannerConf({
      headers: this.props.header,
      data: {
        requestType: 1, // 0App 1h5
      },
      ...getProxyConfig(this.props.app),
    }).then(res => {
      this.setState({
        bannerData: res || [],
      })
    }).catch(err => {
      this.setState({
        bannerData: [],
      })
    })
  }

  handleClick(banner) {
    if (window.android) {
      window.android.clickBanner(banner.clickUrl, banner.clickType)
    }
  }

  componentDidMount() {
    this.getList();
  }

  render() {
    const { bannerData } = this.state;
    const bannerList = bannerData.map((banner) => {
      // clickType == 2为app内部跳转 1为web链接
      return banner.clickType === 2 ?
      <div key={ banner.bannerIndex } onClick={() => this.handleClick(banner) } className="banner-box"><img src={ banner.imgUrl } alt="MIB" /></div> :
      <a
        className="banner-box"
        target="_blank"
        rel="noopener noreferrer"
        key={ banner.bannerIndex }
        href={ banner.clickUrl }
      >
        <img src={ banner.imgUrl } alt="MIB" />
      </a>
    })

    return <div className="banner">
      <Carousel
        autoplay={false}
        infinite={true}
        selectedIndex={this.state.slideIndex}
        dots={true}
        autoplayInterval={5000}
        style={{
          height: '240px'
        }}
      >
        { bannerList }
      </Carousel>
    </div>
  }
}

export default BannerRef;